import { useParams } from "react-router-dom";
import Navbar from "../../../../components/Navbar/Navbar";
import RemitEOB from "../RemitEOB/RemitEOB";

export default function SingleRemitEOB() {
    const params = useParams();
    const remitId = params.remitId || "";

    return (
        <>
            <Navbar title="Remit EOB" />
            <div className="page">
                <RemitEOB remittanceId={remitId} />
            </div>
        </>
    );
}
